import { createAction, props } from '@ngrx/store';

export const HomeActions = {
    SET_SLUG: '[home] SET_SLUG',
    SET_SCROLL: '[home]: SET_SCROLL',
    LOAD_SEO: '[home]: LOAD_HOME',
    LOAD_SEO_SUCCESS: '[home]: LOAD_HOME_SUCCESS',
    SEND_HOME_PAGE_VIEW: '[home] SEND_HOME_PAGE_VIEW',
    // TODO ECOMDUTI-21233 [TechDebt] - Move to newsletter module
    UNSUBSCRIBE_NEWSLETTER: '[nesletter] UNSUBSCRIBE_NEWSLETTER',
    OPEN_MODAL_UNSUBSCRIBE_NEWSLETTER_SUCCESS: '[nesletter] OPEN_MODAL_UNSUBSCRIBE_NEWSLETTER_SUCCESS',
    OPEN_MODAL_UNSUBSCRIBE_NEWSLETTER_ERROR: '[nesletter] OPEN_MODAL_UNSUBSCRIBE_NEWSLETTER_ERROR',
};

export const SetSlug = createAction(HomeActions.SET_SLUG, props<{ slug: string }>());
export const SetScroll = createAction(HomeActions.SET_SCROLL, props<{ isMagnetized: boolean }>());

export const SendHomePageView = createAction(HomeActions.SEND_HOME_PAGE_VIEW);
export const LoadHomeSeoAction = createAction(HomeActions.LOAD_SEO);

export const UnsubscribeNewsletter = createAction(HomeActions.UNSUBSCRIBE_NEWSLETTER, props<{ email: string }>());
export const OpenModalUnsubscribeNewsletterSuccess = createAction(HomeActions.OPEN_MODAL_UNSUBSCRIBE_NEWSLETTER_SUCCESS);
export const OpenModalUnsubscribeNewsletterError = createAction(HomeActions.OPEN_MODAL_UNSUBSCRIBE_NEWSLETTER_ERROR);
